/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import Paths from 'config/paths';
import convertToActions from './paths.utils';

export default convertToActions(Paths);
